import {
  RowBox,
  LeftBox,
  RightBox
} from "../../../../styles/box.style";
import {
  Input,
  InputLabel
} from "../../../../styles/form.style";

const LanuchNew = () => {
  return (
    <>
      <RowBox>
        <LeftBox width="100%">
          <Input type="checkbox" />
          <InputLabel>Launch to all Organizations Filter</InputLabel>
          <Input type="text" style={{ marginLeft: 'auto' }} placeholder="Filter" />
        </LeftBox>
      </RowBox>
    </>
  )
}

export default LanuchNew;